import React from 'react';
import { LayoutBox, LayoutHeader } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styles from '../styles.css';
import SourceDescription from './SourceDescription';

const propTypes = {
  selectedTemplate: PropTypes.object,
  templates: PropTypes.node,
  isLocalizedDesc: PropTypes.bool,
};

function SourcesContainer({
  selectedTemplate,
  templates,
  isLocalizedDesc,
}) {
  const renderTemplatesSection = () => {
    return (
      <>
        <LayoutHeader
          title={
            <FormattedMessage
              id="ui-plugin-inventory-templates.addNewModal.templateSection.label"
              defaultMessage="Template type"
            />
          }
          noActions
        />
        <div className={styles.container}>
          <div>{templates}</div>
        </div>
      </>
    );
  };

  const renderTemplateDescSection = () => {
    return (
      <SourceDescription
        selectedTemplate={selectedTemplate}
        isLocalizedDesc={isLocalizedDesc}
      />
    );
  };

  return (
    <LayoutBox>
      <div>{renderTemplatesSection()}</div>
      <div>{renderTemplateDescSection()}</div>
    </LayoutBox>
  );
}

SourcesContainer.propTypes = propTypes;

export default SourcesContainer;
